import { render, staticRenderFns } from "./TimeQuestion.vue?vue&type=template&id=a827796e&scoped=true&"
import script from "./TimeQuestion.vue?vue&type=script&lang=js&"
export * from "./TimeQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TimeQuestion.vue?vue&type=style&index=0&id=a827796e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a827796e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VTimePicker})
